// extracted by mini-css-extract-plugin
export default {"ProjectTemplate":"xL4dXxYLePyHKuDJOy88","fadein":"q6nTPVwmLYaoIh414xzl","slide-in-left":"sYw2XpTrED1hloMwuFgL","shake":"deCl_ZuFHWE8mf41h2LC"};